module.exports = __webpack_public_path__ + "img/mds_logo.bbe5c3f0.svg";